/* eslint-disable react/jsx-curly-newline */
import React from "react";
import { Box, makeStyles, Typography, Button } from "@material-ui/core";
import clsx from "clsx";
import NextIcon from "./Icons/NextIcon";
import PrevIcon from "./Icons/PrevIcon";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    cursor: "pointer",
    height: 16,
  },
  nextIcon: {
    marginLeft: 16,
  },
  dateRange: {
    marginLeft: 20,
    marginRight: 28,
    fontSize: 16,
    fontFamily: "'Open Sans', sans-serif",
  },
  buttonRoot: {
    borderRadius: 0,
    border: "1px solid #eee",
    "&:hover": {
      border: "1px solid #26bbed",
      background: "#fff",
      "& .MuiButton-label": {
        color: "#26bbed",
      },
    },
  },
  buttonLabel: {
    textTransform: "capitalize",
    fontFamily: "'Open Sans', sans-serif",
    color: "#333",
    fontWeight: 400,
    fontSize: 14,
  },
}));

const DateRange = ({
  startDate,
  endDate,
  onPrevClick = () => {},
  onNextClick = () => {},
  onTodayClick = () => {},
}) => {
  const classes = useStyles();
  const [prevColor, setPrevColor] = React.useState("#333333");
  const [nextColor, setNextColor] = React.useState("#333333");

  return (
    <Box className={classes.root}>
      <PrevIcon
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        color={prevColor}
        onMouseEnter={() => setPrevColor("#26BBED")}
        onMouseLeave={() => setPrevColor("#333333")}
        className={classes.icon}
        onClick={onPrevClick}
      />
      <NextIcon
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        color={nextColor}
        onMouseEnter={() => setNextColor("#26BBED")}
        onMouseLeave={() => setNextColor("#333333")}
        className={clsx(classes.nextIcon, classes.icon)}
        onClick={onNextClick}
      />
      <Typography className={classes.dateRange}>
        {startDate} - {endDate}
      </Typography>
      <Button
        variant="outlined"
        size="small"
        classes={{
          root: classes.buttonRoot,
          label: classes.buttonLabel,
        }}
        onClick={onTodayClick}
      >
        Today
      </Button>
    </Box>
  );
};

export default DateRange;
